var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.listener)?_c('home-page-listener'):_vm._e(),((_vm.companyOwnerInStore || _vm.root) && _vm.selectCompanyId)?_c('div',[_c('home-page-company-owner')],1):_vm._e(),(
      (_vm.documentManager || (_vm.learningRequestManager && !_vm.root)) &&
        !_vm.companyOwnerInStore
    )?_c('div',[_c('home-page-document-request-manager')],1):_vm._e(),(_vm.contentManager)?_c('div',[_c('home-page-content-manager')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }